if (!yy.ast) {
    yy.ast = _ast;
    _ast.initialize();
}



//////////////////
// WEBPACK FOOTER
// ./~/jsonpath/include/action.js
// module id = 512
// module chunks = 0